function SectionHeading({ label, children, subtitle, align = 'left' }) {
  const centered = align === 'center';
  return (
    <div className={`section-heading${centered ? ' text-center' : ''}`}>
      {label && <span className="section-label">{label}</span>}
      <div className="heading-bar" />
      <h2>{children}</h2>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
}

export default SectionHeading;
